import { render } from "./ProjectBasicInfoEditor.vue?vue&type=template&id=75fbe21e"
import script from "./ProjectBasicInfoEditor.vue?vue&type=script&lang=js"
export * from "./ProjectBasicInfoEditor.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__